import { useBottlenecks, useUtilizationHeatmap } from '@/api/dashboard';
import { currentMonthUtilByMember, countFullyBooked } from '@/lib/capacity';
import { WidgetBoundary } from '../WidgetBoundary';
import { CapacityPanel } from '../CapacityPanel';
import { WidgetSkeleton } from '../WidgetSkeleton';
import type { BuiltinHostProps } from './hostProps';

export function CapacityHost({ title, minHeight, accountId }: BuiltinHostProps) {
  const bottlenecks = useBottlenecks(accountId);
  const heatmap = useUtilizationHeatmap(accountId);
  const utilByMember = currentMonthUtilByMember(heatmap.data);
  const fullyBooked = countFullyBooked(utilByMember);

  return (
    <WidgetBoundary label={title} minHeight={minHeight}>
      {bottlenecks.isLoading && <WidgetSkeleton />}
      {!bottlenecks.isLoading && bottlenecks.isError && <WidgetSkeleton variant="error" label={title} />}
      {!bottlenecks.isLoading && !bottlenecks.isError && (
        <CapacityPanel bottlenecks={bottlenecks.data ?? []} fullyBookedCount={fullyBooked} utilByMember={utilByMember} title={title} />
      )}
    </WidgetBoundary>
  );
}
